import React, { PureComponent } from 'react';
import { DateTimePickerRange } from '@mic3/platform-ui';

// Locks the value prop while the picker dialog is open so subscription updates
// cannot overwrite the user's in-progress selection. Requires onOpen/onClose
// support in DateTimePickerRange (added in platform-ui).
class DateTimeRange extends PureComponent {
    state = { isOpen: false, lockedValue: undefined };

    render() {
        const { value, ...rest } = this.props;
        const { isOpen, lockedValue } = this.state;
        const displayValue = isOpen && lockedValue !== undefined ? lockedValue : value;
        return (
            <DateTimePickerRange
                {...rest}
                value={displayValue}
                onOpen={() => this.setState({
                    isOpen: true,
                    lockedValue: value !== undefined ? value : null,
                })}
                onClose={() => this.setState({
                    isOpen: false,
                    lockedValue: undefined,
                })}
            />
        );
    }
}

export default DateTimeRange;
